export default "__VITE_ASSET__E5Jx_M6o__"